import Vue from "vue";
import {
  SET_QUESTIONNAIRE_QG_IDS_NOT_EMP,
  TOGGLE_QUESTIONNAIRE_CONTENTS,
  SET_QUESTIONNAIRE_CONTENTS,
  SET_CURRENT_QUESTION_GROUP,
  UPSERT_VALIDATED_ANSWER,
  UPSERT_ANSWER,
  INIT_ANSWER_CACHE,
  TOGGLE_PRE_SUBMIT,
  INIT_VALIDATED_ANSWER_CACHE,
  TOGGLE_CACHE_LOCK,
} from "../mutation.type";
const state = {
  // 显示问卷目录
  showQuestionnaireContents: false,
  // 问卷目录的内容
  contents: [],
  // 非空的问题组的id集合
  questionGroupNotEmpty: [],
  // 当前选中的问题组
  currentQuestionGroup: null,

  // 答案的缓存
  answerCache: {},
  // 验证后的答案缓存
  validatedAnswerCache: {},

  // 是否显示提交准备窗口
  showPreSubmit: false,

  // 锁定缓存，不触发缓存的提交
  lockCache: true,
};

const mutations = {
  [TOGGLE_QUESTIONNAIRE_CONTENTS]: (state, show) => {
    state.showQuestionnaireContents = show;
  },

  [SET_QUESTIONNAIRE_CONTENTS]: (state, contents) => {
    state.contents = contents;
  },

  [SET_QUESTIONNAIRE_QG_IDS_NOT_EMP]: (state, ids) => {
    state.questionGroupNotEmpty = ids;
  },

  [SET_CURRENT_QUESTION_GROUP]: (state, groupId) => {
    state.currentQuestionGroup = groupId;
  },

  [UPSERT_ANSWER]: (state, { key, value }) => {
    if (value) Vue.set(state.answerCache, key, value);
    else Vue.delete(state.answerCache, key);
  },

  [INIT_ANSWER_CACHE]: (state, answer) => {
    state.answerCache = answer;
  },
  [INIT_VALIDATED_ANSWER_CACHE]: (state, answer) => {
    state.validatedAnswerCache = answer;
  },

  [UPSERT_VALIDATED_ANSWER]: (state, { questionGroupId, answer }) => {
    Vue.set(state.validatedAnswerCache, questionGroupId, answer);
  },

  [TOGGLE_PRE_SUBMIT]: (state, status) => {
    state.showPreSubmit = status;
  },

  [TOGGLE_CACHE_LOCK]: (state, lock) => {
    state.lockCache = lock;
  },
};

export default {
  state,
  mutations,
};
